import 'babel-polyfill'

import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import {
    RouterProvider
} from 'react-router-dom'

import { OidcProvider } from 'redux-oidc'

import store from './store'
import UserManager from './services/UserManager'
import './index.scss'
import router from './router'


const container = document.getElementById('root')
const root = createRoot(container)

root.render(
    <Provider store={ store }>
        <OidcProvider userManager={ UserManager } store={ store }>
            <RouterProvider router={ router } />
        </OidcProvider>
    </Provider>
)

